/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { Injectable } from '@angular/core';

/**
 * Provides the ShivaWebPublicConfiguration configuration object with a given root URL.
 */
export function provideShivaWebPublicConfiguration(rootUrl: string) {
  var config = new ShivaWebPublicConfiguration();
  config.rootUrl = rootUrl;
  return {
    provide: ShivaWebPublicConfiguration,
    useValue: config
  };
}

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class ShivaWebPublicConfiguration {
  rootUrl: string = 'http://dataservices.ineotinea-gdfsuez.com:8090/web';
}

